import { IAdminStore } from "src/stores/adminStore.d";
import AdminApi from "src/api/adminApi";
import * as ls from "local-storage";
import { localStorageKeys } from "src/utils/constant";
import authStore from "./authenticationStore";

export class AdminStore implements IAdminStore {
  isLoading: boolean = false;

  private extractToken(res: any): string | undefined {
    if (!res) {
      return undefined;
    }

    return res.accessToken || res.token || res.jwtAuthToken;
  }

  async login(username: string, password: string) {
    try {
      this.isLoading = true;
      const res = await AdminApi.login(username, password);
      const token = this.extractToken(res);
      if (token) {
        authStore.setJWT(token);
        ls.set(localStorageKeys.KEY_TOKEN, token);
      }
      return res;
    } catch (error) {
      console.log("========= error: ", error);
    } finally {
      this.isLoading = false;
    }
  }
}

export default new AdminStore();
